import { render, staticRenderFns } from "./WarehouseEditView.vue?vue&type=template&id=be7def8c"
import script from "./WarehouseEditView.vue?vue&type=script&lang=js"
export * from "./WarehouseEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports